import styled from 'styled-components';

const Wrapper = styled.div`
    .pop-up-content {
        position: absolute;
        top: 10rem;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1;
        display: flex;
        justify-content: center;
        .container {
            display: flex;
            flex-direction: column;
            .image-container {
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
        .message-content {
            width: 20rem;
            text-align: center;
            color: #fff;
        }
    }
`;

export default Wrapper;
